export const phanLoaiSanPham = {
  sections: {
    list: { title: 'Phân loại sản phẩm' },
  },
  titles: { add: 'Thêm phân loại', edit: 'Sửa phân loại' },
  columns: {
    summary: 'Tên phân loại',
    note: 'Ghi chú',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    status: 'Trạng thái',
    onOffAction: 'Bật tắt',
  },
  filter: {
    searchPlaceholder: 'Tìm theo tên phân loại...',
    textDetailTitle: 'Bộ lọc chi tiết',
  },
  filters: {
    statusAll: 'Tất cả',
  },
  status: {
    dangHoatDong: 'Đang hoạt động',
    ngungHoatDong: 'Ngừng hoạt động',
  },
  messages: {
    loadError: 'Không tải được danh sách phân loại.',
    deleteSuccess: 'Đã xóa phân loại.',
    noData: 'Không có phân loại.',
    listSummary: 'Tổng {count} mục',
    saveSuccess: 'Đã lưu phân loại.',
    statusChanged: 'Đã cập nhật trạng thái.',
    selectedCount: 'Đã chọn {count}',
    deleteSelected: 'Xóa đã chọn ({count})',
    bulkDeleteConfirm: 'Xóa {count} phân loại đã chọn?',
    bulkDeleteSuccess: 'Đã xóa {count} phân loại',
    bulkDeletePartial: 'Đã xóa {ok}/{total}. {failed} mục không xóa được.',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
    bulkDeleteNoneSelected: 'Chưa chọn phân loại nào để xóa',
  },
  form: {
    tenPhanLoai: 'Tên phân loại',
  },
  validation: {
    tenRequired: 'Vui lòng nhập tên phân loại.',
  },
}
